import reducer from './reducers/index';
import routes from '../routes'
import * as interviewsActions from './actions';
import * as interviewsOperations from './operations';
import * as interviewsSelectors from './selectors';

export {
    interviewsOperations,
    interviewsSelectors,
    interviewsActions,
};

export default {
    reducer,
    routes
};
